<template>
    <div>
        <div class="input mb-5 flex  justify-between items-center">
            <p class="w-full mb-2 md:mb-0 md:w-1/2 text-gray-500 font-medium text-sm">
                {{ information }}
            </p>

            <div class="w-full mb-5 md:w-52 md:mb-0">
                <input
                    v-model="search"
                    type="search"
                    class="focus:outline-none outline-none"
                    :placeholder="`Pesquisar ${isTypeSelect.name}`"
                >
            </div>
        </div>
        <div
            v-if="isUpload"
            class="absolute top-4 sm:top-6 w-full -m-4 sm:-m-6 h-full flex items-center justify-center bg-neutral-700 bg-opacity-75 transition-opacity"
        >
            <div class="flex flex-col items-center  py-4 ">
                <img
                    src="@/assets/images/others/spinner.svg"
                    alt=""
                    class="w-10 h-10 mr-2"
                >
                <span class="dark:text-gray-200"> Fazendo o upload, Aguarde ... </span>
            </div>
        </div>
        <div class=" overflow-y-auto h-80 xl:h-96 ">
            <div
                v-if="isInitialize"
                class="mt-10"
            >
                <RequestInfo />
            </div>
            <ul
                v-else-if="query.length > 0"
                role="list"
                class=" divide-gray-200 dark:divide-neutral-700 grid grid-cols-1 gap-2 sm:grid-cols-2 lg:grid-cols-2"
            >
                <li
                    v-for="file in query"
                    :key="file.id"
                    class="py-3 sm:py-2 dark:bg-neutral-700 rounded-lg px-2 "
                >
                    <div class="flex items-center space-x-4 ">
                        <div class="flex-shrink-0">
                            <img
                                v-if="file.type === 'image'"
                                :src="file.source"
                                :alt="file.name"
                                class="object-cover object-center pointer-events-none group-hover:opacity-75 w-12 h-12 rounded-full "
                                @error="fixedNoPhoto"
                            >
                            <Unicon
                                v-else
                                :name="isTypeSelect.icon"
                                class="mt-1 w-6 h-6 dark:text-neutral-300"
                            />
                        </div>
                        <div class="flex-1 min-w-0">
                            <p class="text-sm font-medium text-gray-900 truncate dark:text-white">
                                {{ file.name }}
                            </p>
                            <p class="text-sm text-gray-500 truncate dark:text-gray-400">
                                {{ file.size }}
                            </p>
                        </div>
                        <div class="inline-flex items-center text-base font-semibold dark:font-normal text-gray-900 dark:text-white">
                            <ButtonForm
                                type="buttom"
                                :disabled="disabled"
                                content=""
                                :color="isClick === file.id ? 'primary' : 'gray'"
                                :icon="isClick === file.id ? 'check-circle' : 'circle'"
                                @click="isClick = file.id; emit('selected',file)"
                            />
                        </div>
                    </div>
                </li>
            </ul>
            <NotFoundInfo
                v-else-if="search != ''"
                title="Opps!!! nada encontrado, revise o seu filtro"
                tagline="Não encontramos nenhum arquivo correspondente a sua pesquisa"
                icon="comment-question"
            />
            <NotFoundInfo
                v-else-if="files.length === 0"
                :title="dataPage[type].notfound"
                tagline="Clique no botão abaixo e faça o upload do seu arquivo"
                icon="times"
            />
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, defineProps, defineEmits, defineAsyncComponent, onBeforeMount, watch } from 'vue'
    import { useLibraryStore  } from '@/stores/library'
    import { fixedNoPhoto } from '@/utils/image'
    import ButtonForm from '@/components/utils/ButtonForm.vue'
    import { isSelectLibrary, dataPage } from '@/components/library/utils'
    import RequestInfo from '@/components/UI/RequestInfo.vue'

    const  NotFoundInfo = defineAsyncComponent(() => import('@/components/UI/NotFoundInfo.vue'))
    const props = defineProps({
        type: {
            type: String,
            default: 'image',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    })
    const emit = defineEmits(['selected', 'request'])

    const library = useLibraryStore()

    const search = ref('')
    const isClick = ref(null)
    const isUpload = ref(false)
    const isInitialize = ref(false)

    const files = computed(() => library.all)
    const countFiles = computed(() => library.count)
    const isTypeSelect = computed(() => isSelectLibrary[props.type])
    const query = computed(() => {
        return search.value === '' ? files.value :
            files.value.filter((item) =>
                item.name.toLowerCase().includes(search.value),
            )
    })
    const information = computed(() => {
        if (countFiles.value > 0) {
            if( props.type === 'image') return `Imagens cadastradas: ${countFiles.value}`
            return `${isTypeSelect.value.name}s cadastrados: ${countFiles.value}`
        }
        return `${isTypeSelect.value.name} cadastrado: ${countFiles.value}`
    })

    async function initialize() {
        return library.fetchItems(props.type)
    }

    onBeforeMount(async() => {
        isInitialize.value = true
        await initialize()
        isInitialize.value = false
    })
    watch(() => isInitialize.value, newValue => emit('request', newValue))
</script>